import { TranslateLoader } from "@ngx-translate/core";
import { Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";
import { StringResourceService } from '../../services/string-resource.service';


export default class ThemingTranslationLoader implements TranslateLoader {

  StringResourceGroups: string[] = [
    'OrganizationsTheming', 'ThemingDetail'
  ];

  constructor(private stringResourceService: StringResourceService) { }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getTranslation(lang: string): Observable<any> {
    return this.stringResourceService
      .GetLocalizedResourceGroups(this.StringResourceGroups)
      .pipe(
        mergeMap((data) => {
          return of(data);
        }),
      );
  }
}
